<template>
     <div>

<!--         <b-tabs v-model="activeTab">-->
<!--             <b-tab-item label="ระบบใหม่(ตั้งแต่วันที่ 20/7/2015)" >-->
<!--                 <template slot="header">-->
<!--                     <span> ระบบใหม่(ตั้งแต่วันที่ 20/7/2015) <b-tag  type="is-info" rounded  >  {{ listoflabopdtarget_v2ModifyDate.length }}   </b-tag> </span>-->
<!--                 </template>-->
<!-- {{listoflabopdtarget_v2}} -->

<!-- {{OPDSelected}} -->
<!-- {{filedDefaultSort}} -->
 
                 <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                 <nav class="level">
                     <div class="level-left">
                         <div class="level-item">
                             <b-button @click="chengeToDefaultField(true)" ref="refreshListLAB">refresh</b-button>
                          </div>
                         <div class="level-item">
                             <b-dropdown
                                     v-model="datWantToSeeModel"
                                     multiple
                                     aria-role="list"
                                     >
                                 <button class="button  is-success" type="button" slot="trigger" >
                                     <span>Filter to ({{ datWantToSeeModel.length }})</span>
                                     <b-icon icon="menu-down"></b-icon>
                                 </button  >

                                 <b-dropdown-item v-for="datGrpUniq in datGrpUniqs" :value="datGrpUniq" :key="datGrpUniq" aria-role="listitem">
                                     <span>{{datGrpUniq}}</span>
                                 </b-dropdown-item>

                             </b-dropdown>
                         </div>
                         <div class="level-item">
                             <b-taglist>
                                 <b-tag type="is-primary" v-for="datWantToSee_ in datWantToSeeModel" :key="datWantToSee_">{{datWantToSee_}}
                                 </b-tag>
                             </b-taglist>
                         </div>


                     </div>
                     <div class="level-right">
                          <!-- <div class="level-item">
                             <b-button @click="chengeToDefaultField(true)" ref="refreshListLAB">refresh</b-button>
                          </div> -->
                     </div>
                 </nav>
   <!-- :default-sort="filedDefaultSort"   -->
   <b-input placeholder="Type For Search Lab No." v-model="searchTxt"  ></b-input>
                 <b-table
                          :data="isEmpty ? [] : listoflabopdtarget_v2ModifyDateFilter"
                          bordered
                          striped
                          narrowed
                          hoverable
                          focusable
                          mobile-cards
                          v-if="showTable"
                          ref="myTable"

                          :key="listoflabopdtarget_v2ModifyDateFilter.uuid"
                          
                          paginated
                          pagination-size="is-medium"
                          pagination-position="bottom"
                          :current-page.sync="currentPage"
                          :per-page="perPage"
                          
                          
                         
                          :default-sort="filedDefaultSort"
                          :default-sort-direction="defaultSortDirection"
                          :sort-icon="sortIcon"
                          :sort-icon-size="sortIconSize"
                          :debounce-page-input="inputDebounce"
                          
                          >


                         <b-table-column  label="Lab No."  centered  v-slot="props" width="15%">
                             <b-button :type=" props.row.status_cbc_lab ? 'is-info' :  'is-danger is-light'  "
                              @click="viewLabEmitBy_ListOfLabEachOPD({'id' : props.row.idlab ,'kindoflab' : props.row.kind})"
                              :icon-left=" props.row.status_cbc_lab ? '' :  'cancel'  "
                              > 
                                 <text-highlight :queries="queries">      {{ props.row.idlab }}  </text-highlight>
                             </b-button>

                              
                             <!-- <span v-if="!props.row.status_cbc_lab" class="has-text-danger">
                                  (Disabled)
                             </span> -->

                             
                              
 
                         </b-table-column>


                         <b-table-column   label="Kind"    v-slot="props" width="4%">
                                 <span class="tag is-warning"  >
                                              {{props.row.kind}}
                                 </span>
                         </b-table-column>


                         <b-table-column   label="Detail"    v-slot="props"     >
                           <b-taglist v-if="props.row.tests.length>0">
                             <b-tag  v-for="tests in props.row.tests" :key="tests"  >{{tests}}</b-tag>
                           </b-taglist>
                           <b-taglist v-if="props.row.tests_v3.length>0">
                             <b-tag  v-for="tests in props.row.tests_v3" :key="tests"  >{{tests}}</b-tag>
                           </b-taglist>
                         </b-table-column>



                         <b-table-column  label="Request" field="datetime_req_number" sortable   width="10%" v-slot="props">
                              <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_req_ts" > {{ props.row.datetime_req_ts }}</b-tag>
                         </b-table-column>

                         <b-table-column  label="Accept" field="datetime_accept_number"  sortable  width="10%" v-slot="props">
                             <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_accept_ts" > {{ props.row.datetime_accept_ts }}</b-tag>
                         </b-table-column>

                         <b-table-column   label="Cancel" field="datetime_cancel_number"  sortable width="10%" v-slot="props">
                             <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_cancel_ts" > {{ props.row.datetime_cancel_ts }}</b-tag>
                         </b-table-column>

                         <b-table-column   label="Reject" field="datetime_reject_number" sortable   width="10%" v-slot="props" >
                             <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_reject_ts" > {{ props.row.datetime_reject_ts }}</b-tag>
                         </b-table-column>

                         <b-table-column  label="Result"  field="datetime_resulted_number"  sortable   width="10%" v-slot="props">
                             <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_resulted_ts" > {{ props.row.datetime_resulted_ts }}</b-tag>
                         </b-table-column>

                         <b-table-column  label="Result Last Update"  field="datetime_resulted_n_number"  sortable   width="15%" v-slot="props">
                             <b-tag rounded   type="is-primary is-light" v-if="props.row.datetime_resulted_ts_n" > {{ props.row.datetime_resulted_ts_n }}</b-tag>
                         </b-table-column>

     

                         <b-table-column  label="Status" width="10%"  v-slot="props">
                             <span class="tag"  :class="labStatusColor(props.row.status )" >
                                                               {{props.row.status}}
                             </span>
                         </b-table-column>

                         <b-table-column  label="Pathologist" v-slot="props">
                             <small>{{ props.row.pathologist }} </small>
                         </b-table-column>




                     <template slot="empty">
                         <section class="section">
                             <div class="content has-text-grey has-text-centered">
                                 <p>
                                     <b-icon
                                             icon="emoticon-sad"
                                             size="is-large">
                                     </b-icon>
                                 </p>
                                 <p >Nothing here.</p>
                             </div>
                         </section>
                     </template>
                 </b-table>
<!--             </b-tab-item>-->

<!--             <b-tab-item label="รายการเก่า">-->

<!--             </b-tab-item>-->
<!--        </b-tabs>-->



     </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import getISO8601ToYearMonthDate from "../mixins/methods/getISO8601ToYearMonthDate";
    import labStatusColor from "../mixins/methods/labStatusColor";
    import { genUUID } from '@/utils.js'

    export default {
        name: "ListOfLabEachOPD",
        mounted() {
            // console.log("Mount ListOfLabEachOPD")
            this.searchTxt = ''
        },
        computed:{
            ...mapState({
                listoflabopdtarget_v2 : state => state.listoflab_opdtarget.listoflabopdtarget_v2,
                docKind : state => state.master_data.docKind,
                datGrpUniqs : state => state.listoflab_opdtarget.datGrpUniqs,
                datWantToSee : state => state.listoflab_opdtarget.datWantToSee,


                OPDSelected : state => state.opd_target.opd_selected,
            }) ,

            datWantToSeeModel:{
                get: function () {
                    return this.datWantToSee
                },
                set: function (newValue) {
                    this.produceDatWantToSee(newValue)
                }
            },
            queries(){
                return this.searchTxt.split(" ");
            },
            listoflabopdtarget_v2ModifyDateFilter (){
                return this.listoflabopdtarget_v2ModifyDate.filter(dat=>{
                    if( this.datWantToSee.indexOf(dat.kind)>-1){
                     //   console.log(dat.idlab)
                     if    (dat.idlab.toUpperCase().indexOf(this.searchTxt.toUpperCase()) > -1  ){
                        return dat 
                     }
                       
                    }
                })
            },

            listoflabopdtarget_v2ModifyDate  () {

                // {
                //     "idopd": "63007782",
                //     "idlab": "63041123",
                //     "opdname": "กระปุก  (I)",
                //     "owner_name": "ศิริภรณ์  มีนสุข",
                //     "status": "RESULT",
                //     "gender": "F",
                //     "age_day": 1007,
                //     "age": "2 Y 9 M 7 D",
                //     "kind": "CBC",
                //     "automate": "0",
                //     "datetime_req_ts": "2020-05-04T07:19:05",
                //     "user_req": "พราวัน ทรงประยูร",
                //     "datetime_accept_ts": "2020-05-04T07:41:41",
                //     "user_accept": "กมลวรรณ วรรณสุทธิ์",
                //     "datetime_cancel_ts": null,
                //     "user_cancel": " ",
                //     "datetime_reject_ts": null,
                //     "user_reject": " ",
                //     "datetime_resulted_ts": "2020-05-04T09:41:36",
                //     "user_resulted": "LIS SOFTWARE",
                //     "pathologist": ""
                // },


                return this.listoflabopdtarget_v2.map(dat=>{
                     
                    var  tmp_datetime_req_ts =   null
                    var  tmp_datetime_accept_ts = null
                    var  tmp_datetime_cancel_ts = null
                    var  tmp_datetime_reject_ts = null
                    var  tmp_datetime_resulted_ts = null
                    var  tmp_datetime_resulted_ts_n = null  



                    var  tmp_datetime_req_number = null 
                    var  tmp_datetime_accept_number = null 
                    var  tmp_datetime_cancel_number = null 
                    var  tmp_datetime_reject_number = null 
                    var  tmp_datetime_resulted_number = null 
                    var  tmp_datetime_resulted_n_number = null 




                    tmp_datetime_req_ts  =        dat.datetime_req_ts !== null
                                                    ?
                                                    ` ${ this.getISO8601ToYearMonthDate(dat.datetime_req_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_req_ts).second } `
                                                    :
                                                    null

                    tmp_datetime_accept_ts =         dat.datetime_accept_ts !== null
                                                    ?
                                                    ` ${ this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_accept_ts).second } `
                                                    :
                                                    null

                    tmp_datetime_cancel_ts =        dat.datetime_cancel_ts !== null
                                                    ?
                                                    ` ${ this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_cancel_ts).second } `
                                                    :
                                                    null

                    tmp_datetime_reject_ts =       dat.datetime_reject_ts !== null
                                                    ?
                                                    ` ${ this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_reject_ts).second } `
                                                    :
                                                    null


                    tmp_datetime_resulted_ts =       dat.datetime_resulted_ts !== null
                                                    ?
                                                    ` ${ this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).month} ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts).second } `
                                                    :
                                                    null
                    
                    tmp_datetime_resulted_ts_n =       dat.datetime_resulted_ts_n !== null
                                                    ?
                                                    ` ${ this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts_n).date}  ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts_n).month} ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts_n).year }   -    ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts_n).hour} : ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts_n).minute }  : ${this.getISO8601ToYearMonthDate(dat.datetime_resulted_ts_n).second } `
                                                    :
                                                    null                                
                                                    

                   tmp_datetime_req_number =          dat.datetime_req_ts !== null
                                                        ?
                                                        new Date(dat.datetime_req_ts).getTime()
                                                        :
                                                        null

                    tmp_datetime_accept_number =       dat.datetime_accept_ts !== null
                                                        ?
                                                        new Date(dat.datetime_accept_ts).getTime()
                                                        :
                                                        null                                    

                    tmp_datetime_cancel_number =       dat.datetime_cancel_ts !== null
                                                        ?
                                                        new Date(dat.datetime_cancel_ts).getTime()
                                                        :
                                                        null       
                
                    tmp_datetime_reject_number =       dat.datetime_reject_ts !== null
                                                        ?
                                                        new Date(dat.datetime_reject_ts).getTime()
                                                        :
                                                        null   
                                                        
                                                        
                    tmp_datetime_resulted_number =      dat.datetime_resulted_ts !== null
                                                        ?
                                                        new Date(dat.datetime_resulted_ts).getTime()
                                                        :
                                                        null   
                    
                    tmp_datetime_resulted_n_number =      dat.datetime_resulted_ts_n !== null
                                                        ?
                                                        new Date(dat.datetime_resulted_ts_n).getTime()
                                                        :
                                                        null 
               
               


                   return  {
                        "idopd": dat.idopd,
                        "idlab": dat.idlab,
                        "opdname": dat.opdname,
                        "owner_name": dat.owner_name,
                        "status": dat.status,
                        "gender": dat.gender,
                        "age_day": dat.age_day,
                        "age": dat.age,
                        "kind": dat.kind,
                        "automate": dat.automate,
                        "datetime_req_ts": tmp_datetime_req_ts,
                        "user_req": dat.user_req,
                        "datetime_accept_ts": tmp_datetime_accept_ts,
                        "user_accept": dat.user_accept,
                        "datetime_cancel_ts": tmp_datetime_cancel_ts,
                        "user_cancel": dat.user_cancel,
                        "datetime_reject_ts": tmp_datetime_reject_ts,
                        "user_reject": dat.user_reject,
                        "datetime_resulted_ts": tmp_datetime_resulted_ts,
                        "user_resulted": dat.user_resulted,
                        "datetime_resulted_ts_n": tmp_datetime_resulted_ts_n,
                        "user_resulted_n": dat.user_resulted_n,
                        "pathologist": dat.pathologist,
                        "status_cbc_lab": dat.status_cbc_lab,


                        "id" : dat.id ,
                        "datetime_req_number": tmp_datetime_req_number,
                        "datetime_accept_number": tmp_datetime_accept_number,
                        "datetime_cancel_number": tmp_datetime_cancel_number,
                        "datetime_reject_number": tmp_datetime_reject_number,
                        "datetime_resulted_number": tmp_datetime_resulted_number,
                        "datetime_resulted_n_number": tmp_datetime_resulted_n_number,
                        "uuid" : genUUID(10),
                        "tests" : dat.tests,
                        "tests_v3" : dat.tests_v3,
                        "version" : dat.version

                    }
                })
            }
        },
        mixins:[getISO8601ToYearMonthDate,labStatusColor],
        methods:{
            ...mapActions({
                produceDatWantToSee : 'listoflab_opdtarget/produceDatWantToSee',
                fetchListOfLab_OPDTargetV2 : 'listoflab_opdtarget/fetchListOfLab_OPDTargetV2'
            }),

            viewLabEmitBy_ListOfLabEachOPD(payload){
               this.$emit('viewLabEmitBy_ListOfLabEachOPD',payload)
            },

            chengeToDefaultField(withReload){
        
              this.defaultSortDirection = 'desc'
              this.sortIcon =  'arrow-up'
              this.sortIconSize = 'is-small'
              this.inputDebounce = ''
              this.filedDefaultSort = null
              this.showTable = false
                    //     this.$nextTick(function () {
                    //         this.showTable = true
                    //         this.filedDefaultSort = ['datetime_resulted_n_number','desc']
                    //  });


            //  console.log(withReload)
             if(withReload){
                // console.log("withReload")
                 this.isFullScreenLoading = true
                 this.fetchListOfLab_OPDTargetV2(this.OPDSelected.idopd)
                  .then(()=>{
                    this.filedDefaultSort = ['datetime_resulted_n_number','desc']
                    this.$nextTick(function () {
                            this.showTable = true
                            this.filedDefaultSort = ['datetime_resulted_n_number','desc']
                            this.isFullScreenLoading = false
                     });
                  })


             }else{
                // console.log("without Reload")
                     this.filedDefaultSort = ['datetime_resulted_n_number','desc']
                     this.$nextTick(function () {
                            this.showTable = true
                            this.filedDefaultSort = ['datetime_resulted_n_number','desc']
                     });
                 
             }
             

          
               
            }
        },
        data(){
            return {
                activeTab : 0,
                isEmpty : false,
                currentPage : 1,
                perPage : 5,
                searchTxt : "",


                // datGrpUniqs : [],
                // datWantToSee : []


                defaultSortDirection: 'desc',
                sortIcon: 'arrow-up',
                sortIconSize: 'is-small',
                inputDebounce: '',
                filedDefaultSort : ['datetime_resulted_n_number','desc'], //'datetime_req_number',

                // sortable_datetime_req_number : true, 
                // sortable_datetime_accept_number : true,
                // sortable_datetime_cancel_number : true,
                // sortable_datetime_reject_number : true,
                // sortable_datetime_resulted_number : true,
                // sortable_datetime_resulted_n_number : true,


                showTable : true,


                isFullScreenLoading : false,


            }
        },
        watch:{

        }
    }
</script>

<style scoped>

</style>